import React from 'react'
import Typography from '@material-ui/core/Typography'
import LayoutPage from '../../hoc/LayoutPage/LayoutPage'
import regulations from '../../assets/26/Регламент_работы_стендовой_сессии_1.pdf'
import participants from '../../assets/26/Список_участников_стендовой_сессии_new.pdf'
import report0 from '../../assets/26/doclads/Абдразакова Л., Гильманов А..pdf'
import report1 from '../../assets/26/doclads/Акманова С..pdf'
import report2 from '../../assets/26/doclads/Алексеев А.В..pdf'
import report3 from '../../assets/26/doclads/Асхобов С..pdf'
import report4 from '../../assets/26/doclads/Бартенев Д.Д..pdf'
import report5 from '../../assets/26/doclads/Буренков В.И. , Сенуси М.А..pdf'
import report6 from '../../assets/26/doclads/Ваганова К., Шелудько А..pdf'
import report7 from '../../assets/26/doclads/Гильманов А., Попов В., Шевелев А..pdf'
import report8 from '../../assets/26/doclads/Елисеева Ю..pdf'
import report9 from '../../assets/26/doclads/Жумабаев А.pdf'
import report10 from '../../assets/26/doclads/Казаков Е..pdf'
import report11 from '../../assets/26/doclads/Каюмов Ш., Бекчанов Ш., Зиядуллаева Ш..pdf'
import report12 from '../../assets/26/doclads/Манаков И., Келлер А..pdf'
import report13 from '../../assets/26/doclads/Мирзоев К., Конечная Н..pdf'
import report14 from '../../assets/26/doclads/Морозов К., Чижов К..pdf'
import report15 from '../../assets/26/doclads/Николаева Н., Манакова Н..pdf'
import report16 from '../../assets/26/doclads/ОлимиА.pdf'
import report17 from '../../assets/26/doclads/Поцейко П., Ровба Е..pdf'
import report18 from '../../assets/26/doclads/Ремболович А. Шевелев А., Федоров К..pdf'
import report19 from '../../assets/26/doclads/Рогозина Н..pdf'
import report20 from '../../assets/26/doclads/Рябов К..pdf'
import report21 from '../../assets/26/doclads/Сафонова Т..pdf'
import report22 from '../../assets/26/doclads/Солеев А., Розет И., Мухтаров Я..pdf'
import report23 from '../../assets/26/doclads/Турганов Н..pdf'

const reports = [
  { name: 'Абдразакова Л., Гильманов А.', file: report0 },
  { name: 'Акманова С.', file: report1 },
  { name: 'Алексеев А.В.', file: report2 },
  { name: 'Асхобов С.', file: report3 },
  { name: 'Бартенев Д.Д.', file: report4 },
  { name: 'Буренков В.И., Сенуси М.А.', file: report5 },
  { name: 'Ваганова К., Шелудько А.', file: report6 },
  { name: 'Гильманов А., Попов В., Шевелев А.', file: report7 },
  { name: 'Елисеева Ю.', file: report8 },
  { name: 'Жумабаев А.', file: report9 },
  { name: 'Казаков Е.', file: report10 },
  { name: 'Каюмов Ш., Бекчанов Ш., Зиядуллаева Ш.', file: report11 },
  { name: 'Манаков И., Келлер А.', file: report12 },
  { name: 'Мирзоев К., Конечная Н.', file: report13 },
  { name: 'Морозов К., Чижов К.', file: report14 },
  { name: 'Николаева Н., Манакова Н.', file: report15 },
  { name: 'Олими А.', file: report16 },
  { name: 'Поцейко П., Ровба Е.', file: report17 },
  { name: 'Ремболович А., Шевелев А., Федоров К.', file: report18 },
  { name: 'Рогозина Н.', file: report19 },
  { name: 'Рябов К.', file: report20 },
  { name: 'Сафонова Т.', file: report21 },
  { name: 'Солеев А., Розет И., Мухтаров Я.', file: report22 },
  { name: 'Турганов Н.', file: report23 },
]

const StendReport = () => (
  <LayoutPage headling='Стендовые доклады'>
    <Typography variant='h4' paragraph>
      Стендовая сессия УОМШ-2026
    </Typography>
    <Typography variant='body1' paragraph>
      Стендовая сессия состоится 2 октября с 15:00 до 17:00 по уфимскому времени
      и пройдёт онлайн.
    </Typography>
    <Typography variant='body1' paragraph>
      <a href='https://telemost.yandex.ru/j/69261245851158' target='_blank' rel='noopener noreferrer'>Подключиться к стендовой сессии</a>.
      {' '}Ссылка будет активна 2 октября с 15:00 до 17:00 по уфимскому времени.
    </Typography>
    <Typography variant='body1' paragraph>
      Авторам докладов необходимо подготовить презентацию в любом редакторе
      (рекомендуемый объём — 8–12 страниц) и отправить её в формате PDF на{' '}
      <a href='mailto:ufa.mat.sh@mail.ru'>ufa.mat.sh@mail.ru</a> не позднее 30 сентября.
      Презентации будут доступны на сайте конференции.
    </Typography>
    <Typography variant='body1' paragraph>
      Перед началом сессии авторам нужно подключиться к онлайн-конференции и быть
      готовыми обсудить доклад. Заинтересованные участники также могут подключиться.
      Во время сессии каждый участник может задавать вопросы авторам. При наличии
      вопросов обсуждение доклада длится до 5 минут; во время него демонстрируется
      презентация.
    </Typography>
    <Typography variant='body1' paragraph>
      <a href={regulations} target='_blank' rel='noopener noreferrer'>Открыть регламент в PDF</a>
    </Typography>

    <Typography variant='h4' paragraph>
      Участники стендовой сессии УОМШ-2026
    </Typography>
    <Typography variant='body1' paragraph>
      <a href={participants} target='_blank' rel='noopener noreferrer'>Открыть список участников и докладов в PDF</a>
    </Typography>
    <iframe
      src={participants}
      title='Список участников и докладов стендовой сессии УОМШ-2026'
      style={{ width: '100%', height: '80vh', minHeight: 500, border: 0 }}
    />
    <Typography variant='h4' paragraph style={{ marginTop: 24 }}>
      Презентации докладов
    </Typography>
    <ol>
      {reports.map(({ name, file }) => (
        <Typography component='li' variant='body1' key={file}>
          <a href={file} target='_blank' rel='noopener noreferrer'>{name}</a>
        </Typography>
      ))}
    </ol>
  </LayoutPage>
)

export default StendReport
